import { isSceneEffectType, mergeEffectParams, parseSceneEffectParams, } from '../types/sceneEffects';
export function mapSceneEffectResponse(response) {
    if (!isSceneEffectType(response.effectType))
        return null;
    return {
        id: response.id,
        movieId: response.movieId,
        sceneId: response.sceneId,
        effectType: response.effectType,
        properties: mergeEffectParams(response.effectType, parseSceneEffectParams(JSON.parse(response.properties || '{}'))),
        sorter: response.sorter,
        isEnabled: response.isEnabled,
    };
}
export function toSceneEffectResponse(effect, propertiesOverride) {
    const properties = propertiesOverride ?? effect.properties;
    return {
        id: effect.id,
        movieId: effect.movieId,
        sceneId: effect.sceneId,
        effectType: effect.effectType,
        properties: JSON.stringify(properties),
        sorter: effect.sorter,
        isEnabled: effect.isEnabled,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
    };
}
export function buildUpsertRequest(movieId, sceneId, effectType, isEnabled, existing) {
    const properties = existing?.properties ?? mergeEffectParams(effectType, {});
    return {
        id: existing?.id ?? 0,
        movieId,
        sceneId,
        effectType,
        properties: JSON.stringify(properties),
        sorter: existing?.sorter ?? 0,
        isEnabled,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
    };
}
